import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { PROCESS } from "../../data/content";

export default function Process() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start center", "end center"] });
  const height = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);
  return (
    <section id="process" data-testid="process-section" className="relative py-28 md:py-40 px-6 md:px-10">
      <div className="max-w-5xl mx-auto">
        <span className="font-mono-x text-primary text-xs tracking-[0.35em]">/ 07 — HOW IT WORKS</span>
        <h2 className="mt-6 font-heading font-extrabold tracking-tighter text-4xl md:text-5xl mb-20">From quote to dock</h2>
        <div ref={ref} className="relative pl-10 md:pl-16">
          <div className="absolute left-2 md:left-4 top-0 bottom-0 w-[2px] bg-border" />
          <motion.div style={{ height }} className="absolute left-2 md:left-4 top-0 w-[2px] bg-primary" />
          <div className="space-y-16">
            {PROCESS.map((p, i) => (
              <motion.div key={p.step} data-testid={`process-step-${i}`}
                initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, margin: "-120px" }}
                transition={{ duration: 0.6 }} className="relative">
                <span className="absolute -left-[38px] md:-left-[52px] top-1 w-4 h-4 rounded-full bg-primary ring-4 ring-background" />
                <div className="font-mono-x text-primary text-sm tracking-[0.3em]">{p.step}</div>
                <h3 className="mt-2 font-heading font-bold text-2xl md:text-3xl">{p.title}</h3>
                <p className="mt-3 text-muted-foreground max-w-xl">{p.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
